import { api, unwrap } from './client';
import { activityFromApi } from './_transforms';

export async function getDashboardStats() {
  const data = await unwrap(api.get('/api/dashboard/stats'));
  if (!data) return data;
  return {
    totalMembers: Number(data.totalMembers || 0),
    activeMembers: Number(data.activeMembers || 0),
    pendingMembers: Number(data.pendingMembers || 0),
    inactiveMembers: Number(data.inactiveMembers || 0),
    pilgrimsRegistered: Number(data.pilgrimsRegistered || 0),
    totalRevenue: Number(data.totalRevenue || 0),
    revenueThisYear: Number(data.revenueThisYear || 0),
    revenueThisMonth: Number(data.revenueThisMonth || 0),
    pendingPaymentsCount: Number(data.pendingPaymentsCount || 0),
    monthlyMemberAdds: Number(data.monthlyMemberAdds || 0),
    monthlyRevenue: (data.monthlyRevenue || []).map((v) => Number(v || 0)),
  };
}

export async function getActivity() {
  const data = await unwrap(api.get('/api/dashboard/activity'));
  return (data || []).map(activityFromApi);
}
